import { PartialType, PickType } from '@nestjs/swagger';
import { Exclude } from 'class-transformer';
import { JobPhaseBumpPhotoDto } from './job-phase-bump-photo.dto';
import { JobPhaseBumpPhotoUpdatableInterface } from '../interfaces/job-phase-bump-photo-updatable.interface';

@Exclude()
export class JobPhaseBumpPhotoUpdateDto
  extends PartialType(PickType(JobPhaseBumpPhotoDto, ['fileName', 'metaData']))
  implements JobPhaseBumpPhotoUpdatableInterface {}
